import { UserListTabs } from './enums/user-list-tabs.enum';

export const TABS_CAN_ADD_EMPLOYEE: UserListTabs[] = [UserListTabs.Active, UserListTabs.Inactive];
export const STATUS_KEY: string = 'status';
